<template>
  <a-locale-provider :locale="locale">
    <div class="order-search-container">
      <div class="point-info">
        <table>
          <tr>
            <td>
              <p>您当前虚拟币余额：<span class="point-amount">{{ balance }}</span> </p>
            </td>
            <td>
              <p>可使用虚拟币：<span class="point-amount">{{ usableBalance }}</span> </p>
            </td>
          </tr>
        </table>
      </div>
      <div class="mod-search">
        <a-form layout="horizontal" :label-col="{ span: 6 }" :wrapper-col="{ span: 18 }">
          <a-row>
            <a-col :md="12" :xs="24">
              <a-form-item  label="日期">
                <a-range-picker
                  format="YYYY-MM-DD"
                  :allowClear="false"
                  :disabledDate="disabledDate"
                  v-model="rangeDate"
                  @change="onRangeChange"
                >
                  <template slot="renderExtraFooter">
                    最多只能选择一周以内
                  </template>
                </a-range-picker>
              </a-form-item>
            </a-col>
            <a-col :md="6" :xs="24">
              <a-form-item label="交易类型">
                <a-select placeholder="请选择" :allowClear="true" v-model="type">
                  <a-select-option value="001">
                    增加虚拟币
                  </a-select-option>
                  <a-select-option value="002">
                    消费虚拟币
                  </a-select-option>
                  <a-select-option value="003">
                    过期作废
                  </a-select-option>
                  <a-select-option value="004">
                    系统退还
                  </a-select-option>
                  <a-select-option value="006">
                    退还虚拟币
                  </a-select-option>
                  <a-select-option value="008">
                    增加可使用虚拟币
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="6" :xs="24">
              <a-form-item label="交易状态">
                <a-select placeholder="请选择" :allowClear="true" v-model="status">
                  <a-select-option value="0">
                    待确认
                  </a-select-option>
                  <a-select-option value="1">
                    成功
                  </a-select-option>
                  <a-select-option value="2">
                    撤销
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :md="12" :xs="24">
              <a-form-item label="交易单号">
                <a-input v-model.trim="serialNumber"></a-input>
              </a-form-item>
            </a-col>
            <a-col :md="12" :xs="24" style="text-align: right;">
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button @click="onExport" style="margin-left: 12px;">导出</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <div class="order-search-table">
        <a-table class="order-table"
          rowKey="time"
          :dataSource='pointListData'
          :columns='pointListCols'
          :pagination="pointListPagination"
          :loading="searchLoading"
          @change="pointListChangeHandler"
        >
        </a-table>
      </div>
    </div>
  </a-locale-provider>
</template>

<script>
import './index'
import axios from 'axios'
import '@/components/l8-icon'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import moment from 'moment'
import { pointPage, pointBalance } from '@/apis/agent'

const mainSettings = window.__MICRO_ROOT__ ?? {}
const airline = mainSettings.airline || ''
const pointListCols = [
  {
    title: '日期',
    dataIndex: 'time',
    key: 'time'
  },
  {
    title: '获取虚拟币',
    dataIndex: 'addAmount',
    key: 'addAmount'
  },
  {
    title: '消费虚拟币',
    dataIndex: 'deductAmount',
    key: 'deductAmount'
  },
  {
    title: '当前积分',
    dataIndex: 'balanceValue'
  },
  {
    title: '交易单号',
    dataIndex: 'serialNumber'
  },
  {
    title: '关联订单号',
    dataIndex: 'relatedOrderNo'
  },
  {
    title: '详细说明',
    dataIndex: 'describe'
  }
]

export default {
  data () {
    return {
      locale: zhCN,
      pointListData: [],
      pointListCols: pointListCols,
      pointListPagination: {
        defaultCurrent: 1,
        defaultPageSize: 10,
        pageSizeOptions: ['10', '20', '30'],
        showSizeChanger: true,
        showQuickJumper: true,
        total: 10
      },
      balance: null,
      usableBalance: null,
      searchLoading: true,
      // 查询参数
      page: 1,
      pageSize: 10,
      rangeDate: [moment().subtract(6, 'd'), moment()],
      type: undefined,
      status: undefined,
      serialNumber: ''
    }
  },
  created () {
    this.fetchPayList()
    this.fetchBalance()
  },
  computed: {
    queryParams () {
      const { page, pageSize, rangeDate, type, status, serialNumber } = this
      const params = {
        page,
        pageSize,
        startDate: rangeDate[0].format('YYYY-MM-DD'),
        endDate: rangeDate[1].format('YYYY-MM-DD')
      }

      if (type) {
        params.type = type
      }

      if (status) {
        params.status = status
      }

      if (serialNumber) {
        params.serialNumber = serialNumber
      }

      return params
    }
  },
  methods: {
    onSearch () {
      this.page = 1
      this.$nextTick(() => {
        this.fetchPayList()
      })
    },
    pointListChangeHandler ({ pageSize, current }) {
      this.page = this.pageSize !== pageSize ? 1 : current
      this.pageSize = pageSize

      this.fetchPayList()
    },
    async fetchPayList () {
      const { queryParams } = this
      this.searchLoading = true

      try {
        const res = await pointPage(queryParams)
        this.searchLoading = false

        if (res.content && res.content.length) {
          this.pointListData = res.content
        } else {
          this.pointListData = []
        }

        this.$set(this.pointListPagination, 'current', res.page)
        this.$set(this.pointListPagination, 'total', res.total)
      } catch (err) {
        this.searchLoading = false
        this.$message.error(err.message || '查询失败，请稍后再试')
      }
    },
    async fetchBalance () {
      try {
        const res = await pointBalance({})

        this.balance = res.balance
        this.usableBalance = res.usableBalance
      } catch (err) {
        this.$message.error(err.message || '查询失败，请稍后再试')
      }
    },
    onExport () {
      this.$confirm({
        title: '处理全部数据吗？',
        content: '“取消”为处理当前页面。',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          this.export(true)
        },
        onCancel: () => {
          this.export(false)
        }
      })
    },
    export (isAll) {
      const { queryParams } = this

      axios({
        method: 'post',
        url: '/api/point/export',
        headers: {
          token: this.$ls.get('USER_CENTER_TOKEN'),
          airline,
          channel: 'C' + airline
        },
        data: {
          ...queryParams,
          isAll
        },
        responseType: 'blob'
      }).then(({ status, data }) => {
        if (status === 200) {
          if (!window.Blob) {
            this.$message.error('该浏览器不支持数据流下载，请更换浏览器')
            return
          }

          const blob = new Blob([data])
          const fileName = '虚拟支付列表.xls'

          if ('download' in document.createElement('a')) { // 非IE下载
            const elink = document.createElement('a')
            elink.download = fileName
            elink.style.display = 'none'
            elink.href = URL.createObjectURL(blob)
            document.body.appendChild(elink)
            elink.click()
            URL.revokeObjectURL(elink.href) // 释放URL 对象
            document.body.removeChild(elink)
          } else { // IE10+下载
            navigator.msSaveBlob(blob, fileName)
          }
        } else {
          this.$message.error('网络异常，请稍后再试！')
        }
      }).catch(err => {
        this.$message.error(err.message || '导出失败，请稍后再试')
      })
    },
    disabledDate (current) {
      return current && current > moment().endOf('day')
    },
    onRangeChange ([startDate, endDate]) {
      if (endDate > startDate.clone().add(6, 'd')) {
        this.$message.error('最多只能选择一周以内，即将根据你选择的开始时间调整结束时间')
        this.rangeDate.splice(1, 1, startDate.clone().add(6, 'd'))
      }
    }
  }
}
</script>

<style lang="less">
  .order-search-container {
    padding: 20px;
    position: relative;
  }

  .point-info {
    padding: 10px;
    font-size: 14px;
    background: #f5f5f5;
    margin-bottom: 20px;

    table {
      width: 100%;
    }
  }

  .point-amount {
    color: @primary-color;
  }

  /*订单列表*/
  .order-table {
    table {
      td {
        vertical-align: middle;
      }
    }

    .l8-href {
      text-decoration: underline;
    }
  }

  @media only screen and (max-width: 992px) {

    .order-table {
      table {
        td {
          vertical-align: middle;
          min-width: 120px;
        }
      }

      .ant-table {
        overflow-x: scroll;
        word-break: keep-all;
      }
    }

    .ant-btn.order-primary-btn {
      width: 100%;
    }
  }

  @media (min-width: 1200px) and (max-width: 1300px) {
    .order-search-form   {
      .form-input-xl-fix {
        .ant-input {
          width: 120px;
        }
      }
    }
  }
</style>
